"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCollections = loadCollections;
exports.loadCollection = loadCollection;
exports.createCollection = createCollection;
exports.deleteCollection = deleteCollection;
exports.editCollection = editCollection;
exports.watchLoadCollections = watchLoadCollections;
exports.watchLoadCollection = watchLoadCollection;
exports.watchCreateCollection = watchCreateCollection;
exports.watchDeleteCollection = watchDeleteCollection;
exports.watchEditCollection = watchEditCollection;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = _interopRequireDefault(require("./actions"));

var _utils = require("../../utils");

var _marked = _regenerator["default"].mark(loadCollections),
    _marked2 = _regenerator["default"].mark(loadCollection),
    _marked3 = _regenerator["default"].mark(createCollection),
    _marked4 = _regenerator["default"].mark(deleteCollection),
    _marked5 = _regenerator["default"].mark(editCollection),
    _marked6 = _regenerator["default"].mark(watchLoadCollections),
    _marked7 = _regenerator["default"].mark(watchLoadCollection),
    _marked8 = _regenerator["default"].mark(watchCreateCollection),
    _marked9 = _regenerator["default"].mark(watchDeleteCollection),
    _marked10 = _regenerator["default"].mark(watchEditCollection);

function loadCollections(api, action) {
  var _action$payload, clientId, groupId, search, language, _action$payload$skip, skip, _action$payload$limit, limit, _action$payload$onlin, onlineFilter, _action$payload$group, groupFilter, _action$payload$withA, withArticlesCount, data;

  return _regenerator["default"].wrap(function loadCollections$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, clientId = _action$payload.clientId, groupId = _action$payload.groupId, search = _action$payload.search, language = _action$payload.language, _action$payload$skip = _action$payload.skip, skip = _action$payload$skip === void 0 ? 0 : _action$payload$skip, _action$payload$limit = _action$payload.limit, limit = _action$payload$limit === void 0 ? 20 : _action$payload$limit, _action$payload$onlin = _action$payload.onlineFilter, onlineFilter = _action$payload$onlin === void 0 ? true : _action$payload$onlin, _action$payload$group = _action$payload.groupFilter, groupFilter = _action$payload$group === void 0 ? true : _action$payload$group, _action$payload$withA = _action$payload.withArticlesCount, withArticlesCount = _action$payload$withA === void 0 ? false : _action$payload$withA;
          _context.next = 4;
          return api.getCollections({
            clientId: clientId,
            groupId: groupId,
            search: search,
            language: language,
            skip: skip,
            limit: limit,
            onlineFilter: onlineFilter,
            groupFilter: groupFilter,
            withArticlesCount: withArticlesCount
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadCollectionsSuccess(data));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadCollectionsError(_context.t0));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 9]]);
}

function loadCollection(api, action) {
  var _action$payload2, collectionId, clientId, data;

  return _regenerator["default"].wrap(function loadCollection$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, collectionId = _action$payload2.collectionId, clientId = _action$payload2.clientId;
          _context2.next = 4;
          return api.getCollection({
            collectionId: collectionId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context2.sent;
          _context2.next = 7;
          return (0, _effects.put)(_actions["default"].loadCollectionSuccess({
            data: data
          }));

        case 7:
          _context2.next = 13;
          break;

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 13;
          return (0, _effects.put)(_actions["default"].loadCollectionError(_context2.t0));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 9]]);
}

function createCollection(api, action) {
  var _action$payload3, data, clientId;

  return _regenerator["default"].wrap(function createCollection$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload3 = action.payload, data = _action$payload3.data, clientId = _action$payload3.clientId;
          _context3.next = 4;
          return api.createCollection({
            data: data,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(_actions["default"].createCollectionSuccess());

        case 6:
          _context3.next = 12;
          break;

        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 12;
          return (0, _effects.put)(_actions["default"].createCollectionError(_context3.t0));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 8]]);
}

function deleteCollection(api, action) {
  var _action$payload4, collectionId, clientId;

  return _regenerator["default"].wrap(function deleteCollection$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _action$payload4 = action.payload, collectionId = _action$payload4.collectionId, clientId = _action$payload4.clientId;
          _context4.next = 4;
          return api.deleteCollection({
            collectionId: collectionId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(_actions["default"].deleteCollectionSuccess());

        case 6:
          _context4.next = 12;
          break;

        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 12;
          return (0, _effects.put)(_actions["default"].deleteCollectionError(_context4.t0));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 8]]);
}

function editCollection(api, action) {
  var _action$payload5, data, collectionId, clientId;

  return _regenerator["default"].wrap(function editCollection$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _action$payload5 = action.payload, data = _action$payload5.data, collectionId = _action$payload5.collectionId, clientId = _action$payload5.clientId;
          _context5.next = 4;
          return api.editCollection({
            data: data,
            collectionId: collectionId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(_actions["default"].editCollectionSuccess());

        case 6:
          _context5.next = 12;
          break;

        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 12;
          return (0, _effects.put)(_actions["default"].editCollectionError(_context5.t0));

        case 12:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 8]]);
}

function watchLoadCollections(api) {
  return _regenerator["default"].wrap(function watchLoadCollections$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadCollections), loadCollections, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function watchLoadCollection(api) {
  return _regenerator["default"].wrap(function watchLoadCollection$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadCollection), loadCollection, api);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchCreateCollection(api) {
  return _regenerator["default"].wrap(function watchCreateCollection$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].createCollection), createCollection, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchDeleteCollection(api) {
  return _regenerator["default"].wrap(function watchDeleteCollection$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteCollection), deleteCollection, api);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchEditCollection(api) {
  return _regenerator["default"].wrap(function watchEditCollection$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].editCollection), editCollection, api);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

var collectionsSagas = function collectionsSagas(api) {
  return [(0, _effects.fork)(watchLoadCollections, api), (0, _effects.fork)(watchLoadCollection, api), (0, _effects.fork)(watchCreateCollection, api), (0, _effects.fork)(watchDeleteCollection, api), (0, _effects.fork)(watchEditCollection, api)];
};

var _default = collectionsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map